import { memo } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as LogoIcon } from './assets/logo-full.svg?react';

const LogoContainer = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    width: ${(props) => `${props.size}`}px;
  }

  #Vector {
    fill: ${(props) => `${props.color}`};
  }
`;

const Logo = ({ color = '#050A25', size = 128, className, style, href }) => {
  const navigate = useNavigate();

  return (
    <LogoContainer
      color={color}
      size={size}
      className={className}
      style={style}
      onClick={() => navigate(href || '/passport')}
    >
      <LogoIcon />
    </LogoContainer>
  );
};

export default memo(Logo);
